import { ITemplate } from 'entities/template/template';
import { TemplateTypes } from '../sections/template-list/constants/templateTypes';

/**
 * Checks if a template is an unsubscribe template (either site unsubscribe, global unsubscribe, or from the global site).
 * @param template - The template to check
 * @returns true if the template is an unsubscribe template, false otherwise
 */
export const isUnsubscribeTemplate = (template: ITemplate): boolean => {
  const globalSiteId = import.meta.env.VITE_GLOBAL_SITE_ID;
  return (
    template.type === TemplateTypes.unsubscribe ||
    template.type === TemplateTypes.globalUnsubscribe ||
    template.type === TemplateTypes.unsubscribeEmailTracking ||
    template.siteId === globalSiteId
  );
};
